/**
 * Splits an ingredient id into the raw ingredient id and the modifier group
 * that included pricing encodes into it (`groupId * 100_000_000 + ingredientId`).
 */
export function decodeIngredientId(ingredientId: string) {
  const numericIngredientId = Number(ingredientId);
  const isEncoded =
    Number.isSafeInteger(numericIngredientId) && numericIngredientId >= ENCODED_INGREDIENT_ID_BASE;

  if (!isEncoded) {
    return { rawIngredientId: ingredientId, modificationGroupId: undefined };
  }

  return {
    rawIngredientId: String(numericIngredientId % ENCODED_INGREDIENT_ID_BASE),
    modificationGroupId: String(Math.floor(numericIngredientId / ENCODED_INGREDIENT_ID_BASE)),
  };
}

// ─── Constants ───────────────────────────────────────────────────────────────

const ENCODED_INGREDIENT_ID_BASE = 100_000_000;
